import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

export const DotIndicator = styled.div`
  display: flex;
  justify-content: center;
`;

export const Dot = styled.div`
  width: ${size(1)};
  height: ${size(1)};
  border-radius: 50%;
  background: ${theme.colors.dots.inactive};
  transition: background-color 75ms linear;

  &.active {
    background: ${theme.colors.dots.active};
  }

  & + & {
    margin-left: ${size(1)};
  }
`;
